/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signing_Page_HintInputs */

const cs_signing_page_hint = /** @type {(inputs: Signing_Page_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přehled protokolů a dalších dokumentů odeslaných k e-podpisu. Novou žádost založíte z PDF v kategorii SMLOUVA, PRÁVNÍ, REZERVACE nebo FINANCOVÁNÍ. Živé odeslání čerpá kredity.`)
};

const en_signing_page_hint = /** @type {(inputs: Signing_Page_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Track viewing protocols and other documents sent for e-signature. Start a new request from an existing CONTRACT, LEGAL, RESERVATION, or FINANCING PDF. Live sends use credits.`)
};

/**
* | output |
* | --- |
* | "Track viewing protocols and other documents sent for e-signature. Start a new request from an existing CONTRACT, LEGAL, RESERVATION, or FINANCING PDF. Live s..." |
*
* @param {Signing_Page_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const signing_page_hint = /** @type {((inputs?: Signing_Page_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signing_Page_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signing_page_hint(inputs)
	return cs_signing_page_hint(inputs)
});